/* eslint-disable id-blacklist */
import { avroPhysicalToLogicalMapping } from 'app/shared/utils/column-type.util';
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { fileTypeLinkedServiceTypes } from '../consts/adf-model-type-map-const';
import { avroCompressionTypeOptions } from '../consts/v2Dataset-const';
import { maxRowsPerFileAndPrefixMetadata } from '../consts/metadata-consts';

export const avroMetadata: IDatasetTypeMetadata = {
    type: 'Avro',
    displayName: stringResources.ModelName_AvroDataset,
    supportLinkedServiceTypes: fileTypeLinkedServiceTypes,
    isSource: true,
    isSink: true,
    datasetKind: 'file',
    icon: {
        className: 'svg-i-20x20-Avro'
    },
    isFirstClass: true,
    supportDataFlowWriteComplexStructure: true,
    category: ['File'],
    isV2FormatDataset: true,
    supportDataFlowSink: true,
    supportDataFlowSource: true,
    compressionOptions: avroCompressionTypeOptions,
    supportGetMetadataActivity: true,
    supportDeleteActivity: true,
    displayHierarchicalSchema: true,
    formatWriteSettingControls: [
        maxRowsPerFileAndPrefixMetadata
    ],
    PhysicalToLogicalMapping: avroPhysicalToLogicalMapping
};
